import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../auth/auth.api";
import { TSuccessResponse } from "@/types/general/TSuccessResponse";
import TKRA from "@/types/kra-management/TKRA";
import TPaginationParams from "@/types/general/TPaginationParams";

export const hrActionApi = createApi({
  reducerPath: "hrActionApi",
  tagTypes: ["HRACTION"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllHrAction: builder.query<
      TSuccessResponse<any[]>,
      { pagination?: TPaginationParams; searchKey?: string }
    >({
      query: ({ pagination = {} as any, searchKey }) => {
        const params: Record<any, any> = {};
        const { page = 1, limit = 100 } = pagination;

        if (page && limit) {
          params.page = page;
          params.limit = limit;
        }

        if (searchKey) {
          params.search = searchKey;
        }

        return {
          url: "hr-action-management/hr-action",
          params: params,
        };
      },
    }),

    createHrAction: builder.mutation<TSuccessResponse<null>, any>({
      query: (body) => ({
        url: "hr-action-management/hr-action",
        method: "POST",
        body,
      }),
    }),

    updateHrAction: builder.mutation<
      TSuccessResponse<null>,
      { id: number; data: any }
    >({
      query: ({ id, data }) => ({
        url: `hr-action-management/hr-action/update/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getEditHrAction: builder.query<
      TSuccessResponse<any>, // replace with actual type
      number | string
    >({
      query: (id) => ({
        url: `hr-action-management/hr-action/edit/${id}`,
        method: "GET",
      }),
    }),

    deleteHrAction: builder.mutation<
      TSuccessResponse<null>,
      {
        id: string | number;
      }
    >({
      query: ({ id }) => ({
        url: `hr-action-management/hr-action/${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllHrActionQuery,
  useCreateHrActionMutation,
  useUpdateHrActionMutation,
  useGetEditHrActionQuery,
  useDeleteHrActionMutation,
} = hrActionApi;
